const EN = {
  //todo: studentPaymentPlan Page
  Student: 'Student ',
  Name: 'Name ',
  No: 'No',
  'No Sibling': 'No Sibling',
  Siblings: 'Siblings',
  Parent: 'Parent ',
  Payment: 'Payment ',

  'Student Name': 'Student Name',
  'Student FIN No': 'Student FIN No',
  'Company Name': 'Company Name',
  'Company Address': 'Company Address',
  Email: 'Email ',
  email: 'email ',
  Mother: 'Mother ',
  mother: 'mother ',
  father: 'father ',
  Father: 'Father ',
  guardian: 'guardian',
  Number: 'Number',
  NO: 'NO',
  'Meal Preferences': 'Meal Preferences',
  Class: 'Class',
  Programme: 'Programme',
  Payee: 'Payee',
  Family: 'Family',
  List: 'List',
  Page: 'Page',
  Info: 'Info',
  'info not found': 'info not found',
  Preview: 'Preview',
  Generate: 'Generate',
  'No Data Found': 'No Data Found',
  Invoice: 'Invoice',
  Receipt: 'Receipt',
  Show: 'Show',
  Transaction: 'Transaction',
  Refund: 'Refund',
  'Credit Note': 'Credit Note',
  'Re-Invoice': 'Re-Invoice',
  Action: 'Action',
  'Transactions History': 'Transactions History',
  'CN/Receipt': 'CN/Receipt',
  Document: 'Document',
  Reminder: 'Reminder',
  Reprint: 'Reprint',
  'Apply Payment Plan': 'Apply Payment Plan',
  'View Payment Plan': 'View Payment Plan',
  'Payment Plan': 'Payment Plan',
  Start: 'Start',
  Date: 'Date',
  'Pro-Rate Fees': 'Pro-Rate Fees',
  'Add Discount Plan': 'Add Discount Plan',
  'Sibling Discount': 'Sibling Discount',
  'Payment Plan Details': 'Payment Plan Details',
  'Creation Date': 'Creation Date',
  'Creation By': 'Creation By',
  Level: 'Level',
  'Fee Scheme Name': 'Fee Scheme Name',
  'Validity Starts On': 'Validity Starts On',
  'Validity Ends On': 'Validity Ends On',
  'Tax Applicable': 'Tax Applicable',
  Tax: 'Tax',
  Center: 'Center',
  Currency: 'Currency',
  Status: 'Status',
  'History Detail': 'History Detail',
  Remarks: 'Remarks',
  CN: 'CN',
  RECEIPTS: 'RECEIPTS',
  Mode: 'Mode',
  'Cheque/DD No': 'Cheque/DD No',
  'Bank Name': 'Bank Name',
  'Pick a day': 'Pick a day',
  'Add Item': 'Add Item',
  'Pay Amount': 'Pay Amount',
  'Does this receipt required Invoice': 'Does this receipt required Invoice',
  Cancel: 'Cancel',
  INVOICING: 'INVOICING',
  'Print monthly breakdown': 'Print monthly breakdown',
  'Payment Due Date': 'Payment Due Date',
  'Apply Discount plan': 'Apply Discount plan',
  'Over Payment': 'Over Payment',
  'GST Value': 'GST Value',
  GST: 'GST',
  'Total Amount': 'Total Amount',
  'Generate Receipt Detail(With Transaction History)': 'Generate Receipt Detail(With Transaction History)',
  'Transaction History Detail': 'Transaction History Detail',
  'Left Over Payment': 'Left Over Payment',
  Amount: 'Amount',
  'Included GST': 'Included GST',
  OVERPAYMENT: 'OVERPAYMENT',
  'There are ': 'There are ',
  'overpayment items in your selection': 'overpayment items in your selection',
  Proceed: 'Proceed',
  Yes: 'Yes',
  'No ': 'No',
  'Email To': 'Email To',
  Title: 'Title',
  Description: 'Description',
  Send: 'Send',
  Overview: 'Overview',
  To: 'To',
  Address: 'Address',
  'First Name': 'First Name',
  'Last Name': 'Last Name',
  'Registration Date': 'Registration Date',
  'Center Name': 'Center Name',
  Details: 'Details ',
  'Payment Date': 'Payment Date',
  'Item Description': 'Item Description',
  'GST Applicable': 'GST Applicable',
  'Docs Status': 'Docs Status',
  'Docs Type': 'Docs Type',
  Total: 'Total',
  'Total(IncludedGst)': 'Total(IncludedGst)',
  'Invoice Name': 'Invoice Name',
  'Invoice Date': 'Invoice Date',
  'Invoice Amount': 'Invoice Amount',
  'Outstanding Amount': 'Outstanding Amount',
  'Invoice Due Date': 'Invoice Due Date',
  'Transaction Type': 'Transaction Type',
  'Document Number': 'Document Number',
  'Document Status': 'Document Status',
  'Total (Incl. GST)': 'Total (Incl. GST)',
  'Created By': 'Created By',
  'Payment Schedule': 'Payment Schedule',
  Timeline: 'Timeline',
  'Item Type': 'Item Type',
  'Item Name': 'Item Name',
  'Calculation category': 'Calculation category',
  Message: 'Message',
  'Payment item cannot be deleted': 'Payment item cannot be deleted',
  Delete: 'Delete ',
  More: 'More',
  'Invoice To': 'Invoice To',
  //todo: studentPaymentPlan Page

  //todo: Homepage
  Students: 'Students',
  'NEW STUDENT': 'NEW STUDENT',
  'VIEW ALL': 'VIEW ALL',
  CLASSES: 'CLASSES',
  'STUDENT LIST': 'STUDENT LIST',
  'Student List': 'Student List',
  'New Enrollment': 'New Enrollment',
  Withdraw: 'Withdraw',
  Transferred: 'Transferred',
  Statistic: 'Statistic',
  'No Record Yet': 'No Record Yet',
  'Student Forecast': 'Student Forecast',
  Month: 'Month',
  'Student Movement': 'Student Movement',
  'Student Attendance': 'Student Attendance',
  'Please Wait': 'Please Wait',
  'Search Class': 'Search Class',
  'Total Present': 'Total Present',
  'Total Not Present': 'Total Not Present',
  'Total Students': 'Total Students',
  'Students by level': 'Students by level',
  Present: 'Present',
  'Not Present': 'Not Present',
  January: 'January',
  February: 'February',
  March: 'March',
  April: 'April',
  May: 'May',
  June: 'June',
  July: 'July',
  //todo: Homepage

  //todo studentListPayment page
  'Student NO': 'Student NO',
  'Student First Name': 'Student First Name',
  'Student Last Name': 'Student Last Name',
  Select: 'Select ',
  'Parent Name': 'Parent Name',
  Search: 'Search',
  Filter: 'Filter',
  'PLEASE SEARCH TO VIEW LIST': 'PLEASE SEARCH TO VIEW LIST',
  'Guided Tour': 'Guided Tour',
  UpdateLevelClass: 'UpdateLevelClass',
  'Student Information': 'Student Information',
  Blacklist: 'Blacklist',
  Graduated: 'Graduated',
  Waitlist: 'Waitlist',
  Void: 'Void',
  Withdrawn: 'Withdrawn',
  Pending: 'Pending',
  Active: '',
  Closed: 'Closed',
  'Student ID': 'Student ID',
  '': '',
  '': '',
  '': '',
  '': '',
  '': '',
  '': '',
  '': '',
  //todo studentListPayment page

  //todo studentCourseList
  'Commencement Date': 'Commencement Date',
  '': '',
  '': '',
  '': '',
  '': '',
  '': '',
  '': '',
  '': '',
  //todo studentCourseList

  //todo NewFeed Page
  Feed: 'Feed ',
  Edit: 'Edit ',
  Profile: 'Profile ',
  Photo: 'Photo ',
  // "Attendance":"Attendance ",
  Report: 'Report',
  Result: 'Result ',
  item: 'item ',
  one: 'one',
  two: 'two',
  three: 'three',
  'ARE YOU SURE': 'ARE YOU SURE?',
  PROFILE: 'PROFILE ',
  PHOTO: 'PHOTO ',
  "Once you delete a post, you can't undo it": "Once you delete a post, you can't undo it.",
  'Feed Not Found': 'No post created',
  BROWSE: 'BROWSE',
  Teacher: 'Teacher ',
  'My Post': 'My Post',
  'All Post': 'All Posts',
  'New Post': 'New Post',
  Hashtag: 'Hashtag',
  "Please type in your word without '#'. Add your tag one per line.": "Please type in your word without '#'. Add your tag one per line.",
  '* use hashtag moments or Moments for post to appear under parent Moments.': '* use hashtag moments or Moments for post to appear under parent Moments.',
  'All Moments Post': 'All Moments Post',
  'Search Moment': 'Search post',
  //todo NewFeed Page

  //todo singleFeedComponent Page
  Post: 'Post',
  LIKE: 'Like',
  LOVE: 'LOVE',
  WOW: 'WOW',
  HAHA: 'HAHA',
  SAD: 'SAD',
  'Write a comment': 'Write a comment',
  'More Comment': 'More Comment',
  Comment: 'Comment',
  'Load More': 'Load More',
  'Seen by': 'Seen by',
  //todo singleFeedComponent Page

  //todo Gallery Page
  Create: 'Create ',
  new: 'new ',
  folder: 'folder ',
  Upload: 'Upload ',
  //"Select":"Select ",
  All: 'All ',
  Unselect: 'Unselect ',
  Download: 'Download ',
  View: 'View ',
  Move: 'Move ',
  'Post as learning moment': 'Post as learning moment',
  'Post as Updates': 'Post as Updates',
  Remove: 'Remove ',
  Back: 'Back ',
  Rename: 'Rename ',
  Portfolio: 'Portfolio ',
  Updates: 'Updates ',
  Folder: 'Folder ',
  'Are you sure you want to delete the folder and the selected image(s)': 'Are you sure you want to delete the folder and the selected image(s)',
  'Are you sure you want to delete the selected image(s)': 'Are you sure you want to delete the selected image(s)',
  'Are you sure you want to remove the folder': 'Are you sure you want to remove the folder',
  'Go Back': 'Go Back',
  'Drop file(s) here to upload': 'Drop file(s) here to upload',
  New: 'New ',
  Item: 'Item ',
  Confirm: 'Confirm ',
  'Move item(s) to': 'Move item(s) to',
  //todo Gallery Page

  //todo NewBroadCast Page
  Broadcast: 'Broadcast ',
  BROADCAST: 'BROADCAST ',
  Import: 'Import ',
  Image: 'Image ',
  By: 'By ',
  'Choose a file': 'Choose a file',
  'REMOVE ALL': 'REMOVE ALL',
  Content: 'Content',
  'Please enter a title': 'Please enter a title',
  Submit: 'Submit',
  'Please contact Kagami administrator': 'Please contact Kagami administrator',
  'Select File(s)': 'Select File(s)',
  'Submission Successful': 'Submission Successful',
  'Broadcast Added': 'Broadcast Added',
  'Broadcast List': 'Broadcast List',
  'Broadcast Details': 'Broadcast Details',
  'Read More': 'Read More',
  //todo NewBroadCast Page

  //todo sidebar Component
  Notifications: 'Notifications ',
  Event: 'Event ',
  Media: 'Media ',
  Add: 'Add ',
  Close: 'Close ',
  'Post Feed Msg': ' posted new post in Feed.',
  'Post Comment Feed Msg': ' posted a new comment.',
  'Post Broadcast Msg': ' posted new broadcast in Broadcast.',
  'Post Portfolio Msg': ' posted new moments in Moments.',
  'Notif Empty Message': 'No Notification Found',
  'Not Found': 'Not Found',
  'Travel Declaration': 'Travel Declaration',
  //todo sidebar Component

  //todo NewMedia page
  Gallery: 'Gallery ',
  Selected: 'Selected ',
  'Whoops. Something went wrong': 'Whoops. Something went wrong ',
  'Please check your fields and try again': ' Please check your fields and try again ',
  'Please enter folder name': 'Please enter folder name',
  'Download Selected': 'Download Selected',
  'New Folder': 'New Folder',
  'Move To': 'Move To',
  'Learning Journey': 'Learning Journey',
  'Unselect All': 'Unselect All',
  OK: 'OK',
  'Please confirm you want to delete the selected media': 'Please confirm you want to delete the selected media',
  Moment: 'Moments',
  'Learning Moment': 'Learning Moment',
  //todo NewMedia page

  //todo Attendance List Page
  Attendance: 'Attendance',
  'Thermal Scanner Import': 'Thermal Scanner Import',
  'Parents Contact': 'Parents Contact',
  'Pickup Mode': 'Pickup Mode',
  ECA: 'ECA',
  Nil: 'Nil',
  Save: 'Save',
  Import: 'Import',
  'Please select Class...': 'Please select Class...',
  'No Student Found...': 'No Student Found...',
  'Select Class': 'Select class',
  'Select Attendance For All': 'Select Attendance For All',
  ECA: 'ECA',
  Present: 'Present',
  Absent: 'Absent',
  Late: 'Late',
  Sick: 'Sick',
  'On Holiday': 'On Holiday',
  'Sent Home': 'Sent Home',
  Require: 'Require',
  'Please at least tick at least one row to update': 'Please at least tick at least one row to update',
  Error: 'Error',
  'Error! Please try again later': 'Error! Please try again later',
  Success: 'Success',
  'Successfully saved': 'Successfully saved',
  //todo Attendance List Page

  //todo bus attendance poge
  'Attendance Remark': 'Attendance Remark',
  'Show Mobile': 'Show Mobile',
  'Class (Level)': 'Class (Level)',
  ' was copied to the clipboard.': ' was copied to the clipboard.',
  //todo bus attendance poge

  //todo daily routine
  'Daily Routine': 'Daily Routine',
  'Mass Update': 'Mass Update',
  'single Update': 'single Update',
  'Please select a student ...': 'Please select a student ...',
  'Select Student': 'Select student',
  'Select Status': 'Select status',
  'Select Activity': 'Select Activity',
  Rest: 'Rest',
  Nap: 'Nap',
  Sleep: 'Sleep',
  Remark: 'Remark',
  'Bottle-Type': 'Bottle-Type',
  Solid: 'Solid',
  'Latch On': 'Latch On',
  Menu: 'Menu',
  Formula: 'Formula',
  'Breast Milk': 'Breast Milk',
  Left: 'Left',
  Right: 'Right',
  Poop: 'Poop',
  Texture: 'Texture',
  Creamy: 'Creamy',
  Firm: 'Firm',
  Hard: 'Hard',
  Watery: 'Watery',
  Hygiene: 'Hygiene',
  'Diaper Change': 'Diaper Change',
  'Shower&Diaper Change': 'Show&Diaper Change',
  Shower: 'Shower',
  Brown: 'Brown',
  Tan: 'Tan',
  Yellow: 'Yellow',
  Green: 'Green',
  Black: 'Black',
  Color: 'Color',
  'Todays Activity': "Today's Activity",
  'Rest|Nap': 'Rest>Nap',
  'Rest|Sleep': 'Rest>Sleep',
  'Feed|Bottle-Type|Formula': 'Feed>Bottle-Type>Formula',
  'Feed|Bottle-Type|Breast Milk': 'Feed>Bottle-Type>Breast Milk',
  'Feed|Solid': 'Feed>Solid',
  'Feed|Latch On|Left': 'Feed>Latch On>Left',
  'Feed|Latch On|Right': 'Feed>Latch On>Right',
  'Feed|Menu': 'Feed>Menu',
  'Poop|Texture|Creamy': 'Poop>Texture>Creamy',
  'Poop|Texture|Firm': 'Poop>Texture>Firm',
  'Poop|Texture|Hard': 'Poop>Texture>Hard',
  'Poop|Texture|Watery': 'Poop>Texture>Watery',
  'Poop|Color|Brown': 'Poop>Color>Brown',
  'Poop|Color|Tan': 'Poop>Color>Tan',
  'Poop|Color|Yellow': 'Poop>Color>Yellow',
  'Poop|Color|Green': 'Poop>Color>Green',
  'Poop|Color|Black': 'Poop>Color>Black',
  'Hygiene|Diaper change': 'Hygiene>Diaper change',
  'Hygiene|Shower&Diaper change': 'Hygiene>Shower & Diaper change',
  'Hygiene|Shower': 'Hygiene>Shower',
  'Select All': 'Select All',
  Update: 'Update',
  'Daily Routine Mass Update': 'Daily Routine Mass Update',
  'View Activity': 'View Activity',
  Activity: 'Activity',
  Activities: 'Activity',
  'Back to Student List': 'Back to Student List',
  From: 'From',
  'Get Start Time': 'Start Time',
  'End Time': 'End Time',
  //todo daily routine

  //todo menu
  Administration: 'Attendance',
  'Bus Attendance': 'Bus Attendance',
  'Class Attendance': 'Class Attendance',
  'Daily Routine': 'Daily Routine',
  'ECA Attendance': 'ECA Attendance',
  Logout: 'Logout',
  'My Account': 'My Account',
  English: 'English',
  Chinese: '中文',
  'Bus Management': 'Bus Management',
  'Class Management': 'Class Management',
  'ECA Management': 'ECA Management',
  'Attendance Master': 'Attendance Management',
  'Cancel Schedule': 'Cancel Schedule',
  Parents: 'Parents',
  'Parent Search': 'Parent Search',
  Reports: 'Reports',
  'Attendance Report': 'Attendance Report',
  'Class Attendance Report': 'Class Attendance Report',
  'Student List Report': 'Student List Report',
  'Advance Search': 'Search Student',
  'Create Student': 'Create student',
  //todo menu

  //todo my account
  'Reset Password': 'Password update',
  'Your password needs to have at least one symbol or number, and have at least 8 characters.':
    'Your password needs to have at least one symbol or number, and have at least 8 characters.',
  'Old Password': 'Your current password',
  'New Password': 'Your new password',
  'Confirm New Password': 'Retype your new password',

  //todo my account

  //todo parent
  'Family No': 'Family No',
  "Father's Name": "Father's Name",
  "Mother's Name": "Mother's Name",
  "Guardian's Name": "Guardian's Name",
  'Please search to view the list...': 'Please search to view the list...',
  'Parent Status': 'Parent Status',
  'Fathers Personal Information': "Father's Personal Information",
  'Mothers Personal Information': "Mother's Personal Information",
  'Guardians Personal Information': "Guardian's Personal Information",
  'Middle Name': 'Middle Name',
  'Employment Status': 'Employment Status',
  Occupation: 'Occupation',
  Designation: 'Designation',
  'Home Tel No': 'Home Tel No',
  'Office Tel No': 'Office Tel No',
  'Fax No': 'Fax No',
  'MObile No': 'MObile No',
  Nationality: 'Nationality',
  Religion: 'Religion',
  'Identification Type': 'Identification Type',
  'Identification No': 'Identification No',
  'Identification No Expiry Date': 'Identification No Expiry Date',
  Race: 'Race',
  'Marital Status': 'Marital Status',
  Working: 'Working',
  'Fathers Local Residential Address': "Father's Local Residential Address",
  'Mothers Local Residential Address': "Mother's Local Residential Address",
  'Address 1': 'Address 1',
  'Address 2': 'Address 2',
  'Address 3': 'Address 3',
  City: 'City',
  Country: 'Country',
  'Postal Code': 'Postal Code',
  'EtonHouse Staff': 'EtonHouse Staff',
  'Employee Name': 'Employee Name',
  'Fathers Company Address': "Father's Company Address",
  'Mothers Company Address': "Mother's Company Address",
  'Company Addressee Name': 'Company Addressee Name',
  'Company Address 1': 'Company Address 1',
  'Company Address 2': 'Company Address 2',
  'Company Address 3': 'Company Address 3',
  'Company City': 'Company City',
  'Company Country': 'Company Country',
  'Company Email': 'Company Email',
  'Company Postal Code': 'Company Postal Code',
  'Working Commencement Date': 'Working Commencement Date',
  'Invalid Email Address': 'Invalid Email Address',
  Other: 'Other',
  'Share My Email': 'Share My Email',
  'Share My Mobile Number': 'Share My Mobile Number',
  'School Name': 'School Name',
  Child: 'Child',
  'Re-Active': 'Re-Active',
  //todo parent

  //todo event
  'VIEW BY': 'VIEW BY',
  'Upcoming Events': 'Upcoming Events',
  Latest: 'Latest',
  Calendar: 'Calendar',
  TODAY: 'TODAY',
  Events: 'Events',
  Monthly: 'Monthly',
  Weekly: 'Weekly',
  Daily: 'Daily',
  Type: 'Type',
  'Event Start Date': 'Event Start Date',
  'Event End Date': 'Event End Date',
  'Created by': 'Created by',
  'Event Overview': 'Event Overview',
  'Switch View': 'Switch View',
  Today: 'Today',
  'Error, please try again': 'Error, please try again',
  'Event Removed': 'Event Removed!',
  'Please choose another date': 'Please choose another date',
  'Email Address': 'Email Address',
  Join: 'Join ',
  Guest: 'Guest ',
  'Copy Event': 'Copy Event',
  Tutorial: 'Tutorial',
  'My Calendar': 'My Calendar',
  'All Calendar': 'All Calendar',
  Postback: 'Postback',
  Copy: 'Copy',
  //todo event

  //todo Post_Updates_Component Page
  'Remove All File': 'Remove All File',
  'Content is required': 'Content is required',
  'Please Select Student': 'Please Select Student!',
  'Post Submitted, activity will be active in a while': 'Post Submitted, activity will be active in a while',
  'Please Login to submit post': 'Please Login to submit post',
  'Please fill in content': 'Please fill in content',
  CONTENT: 'CONTENT',
  'Please enter your content here': 'Please enter your content here',
  'Allow user comment': 'Allow user comment?',
  'or select latest posted tags': 'or select latest posted tags.',
  //todo Post_Updates_Component Page

  //todo postPortfolioComponent Page
  'Title is required': 'Title is required',
  Observations: 'Observations',
  'Please enter your observations': 'Please enter your observations',
  'Observations is required': 'Observations is required',
  'Class is required': 'Class is required',
  'Developmental Goals': 'Developmental Goals',
  'Select Development Goals': 'Select developmental goal',
  'Select Learning Domain': 'Select Learning Domain',
  'Select Learning Goal': 'Select Learning Goal',
  'Select Knowledge, Skills and Dispositions (KSD)': 'Select Knowledge, Skills and Dispositions (KSD)',
  'Select Development Goals (moment)': 'Select Learning Domains',
  'Developmental Goals is required': 'Developmental Goals is required',
  'You have selected': 'You have selected:',
  'Analysis & Reflection': 'Analysis & Reflection',
  'Analysis & Reflection is required': 'Analysis & Reflection is required',
  Domain: 'Domain',
  Goals: 'Goals',
  'Key Skill or CLD': 'Key Skill or CLD',
  'Portfolio added': 'Portfolio added.',
  'Successfully Posted': 'Successfully Posted!',
  'Remove All': 'Remove All',
  Analysis: 'Learning Goals',
  'Analysis (moment)': 'Analysis',
  'Analysis is required': 'Analysis is required',
  'Enduring Themes': 'Enduring Themes',
  'Enduring Themes is required': 'Enduring Themes is required',
  'Big Ideas is required': 'Big Ideas is required',
  'Research Question': 'Research Question',
  //todo postPortfolioComponent Page

  //todo newStudentInfo Page
  School: 'School',
  CLevel: 'Level',
  Information: 'Information',
  //todo newStudentInfo Page

  //todo newInvoice Page
  'No record found': 'No record found',
  'Please try again later': 'Please try again later',
  History: 'History',
  //todo newInvoice Page

  //todo myChild Page
  'Child Details': 'Child Details',
  'Children Information': 'Children Information',
  'Preferred Name': 'Preferred Name',
  Gender: 'Gender',
  'Date of Birth': 'Date of Birth',
  'Birth Place': 'Birth Place',
  Fin: 'Fin ',
  'Fin Expiry Date': 'Fin Expiry Date',
  'Birth Certificate': 'Birth Certificate',
  IC: 'IC',
  Passport: 'Passport',
  'Passport Expiry Date': 'Passport Expiry Date',
  'Other Identification': 'Other Identification',
  'Additional Language': 'Additional Language',
  'Dietary Requirement': 'Dietary Requirement',
  'First Language Spoken': 'First Language Spoken',
  'Second Language Spoken': 'Second Language Spoken',
  Membership: 'Membership',
  "Children's Local Residential Address": "Children's Local Residential Address",
  'Postal code required': 'Postal code required',
  'Address 1 required': 'Address 1 required',
  Contact: 'Contact',
  '1st Emergency Contact': '1st Emergency Contact',
  'Contact Person': 'Contact Person',
  'Contact No': 'Contact No',
  'Contact Relation': 'Contact Relation',
  '2nd Emergency Contact': '2nd Emergency Contact',
  'Authorized Children Pickup': 'Authorized Children Pickup',
  Billing: 'Billing',
  'Billing Info': 'Billing Info',
  Payer: 'Payer',
  'Frequent Payments': 'Frequent Payments',
  CDA: 'CDA',
  Subsidy: 'Subsidy',
  'Billing Address': 'Billing Address',
  'Mobile No': 'Mobile No',
  'Email required or Email invalid format': 'Email required or Email invalid format',
  Medical: 'Medical',
  'Medication Allergies List': 'Medication Allergies List',
  Medication: 'Medication',
  'Food Allergies List': 'Food Allergies List',
  Food: 'Food',
  "Student's Medical Details": "Student's Medical Details",
  'Major Ailments List': 'Major Ailments List',
  'Name of Family Doctor': 'Name of Family Doctor',
  'Clinic Address': 'Clinic Address',
  'Clinic Phone No': 'Clinic Phone No',
  'Identify No': 'Identify No',
  Relationship: 'Relationship',
  Termly: 'Termly',
  'Manually Input': 'Manually Input',
  "Student's Local Residential Address": "Student's Local Residential Address",
  'Academic Year Code': 'Academic Year Code',
  'Level Start Date': 'Level Start Date',
  'Level End Date': 'Level End Date',
  'Please fill in all * fields & at least one of ** field': 'Please fill in all * fields & at least one of ** field',
  'Records Successfully Saved': 'Records Successfully Saved',
  'Update Error - Please try again later': 'Update Error - Please try again later',
  'Please fill Medication and Remarks': 'Please fill Medication and Remarks',
  'Please fill Food and Remarks': 'Please fill Food and Remarks',

  // Religion
  BUDDHISM: 'BUDDHISM',
  OTHERS: 'OTHERS',
  HINDU: 'HINDU',
  SIKHS: 'SIKHS',
  CHRISTIAN: 'CHRISTIAN',
  MUSLIM: 'MUSLIM',
  JAINS: 'JAINS',

  // Mother Tongue
  Bilingual: 'Bilingual',
  Hindi: 'Hindi',
  'Mandarin (Foreign)': 'Mandarin (Foreign)',
  10: '10',
  'Mandarin (Local) Level 2': 'Mandarin (Local) Level 2',
  'Mandarin (Local & Presap)': 'Mandarin (Local & Presap)',
  Mandarin: 'Mandarin',
  EAL: 'EAL',
  'EAL Intensive': 'EAL Intensive',
  Japanese: 'Japanese',

  // Meal Preferences
  'Packed lunch': 'Packed lunch',
  'School meal - Normal': 'School meal - Normal',
  'School meal - Special': 'School meal - Special',
  Vegetarian: 'Vegetarian',
  Vegan: 'Vegan',
  Standard: 'Standard',
  Asian: 'Asian',
  Hindu: 'Hindu',
  Jain: 'Jain',
  'School meal - Vegetarian': 'School meal - Vegetarian',

  // Sponsorship Type
  // "Third Party": "Third Party",
  'Father Company': 'Father Company',
  'Mother Company': 'Mother Company',

  // Subsidies
  'Additional Subsidy': 'Additional Subsidy',
  'Child Care Subsidy': 'Child Care Subsidy',
  'Working Mother Subsidy': 'Working Mother Subsidy',
  //todo myChild Page

  //todo ParentRegisterByLink Page
  'Getting Started': 'Getting Started',
  'Already have an account': 'Already have an account?',
  'Sign Up': 'Sign Up',
  Password: 'Password',
  'Registration Success': 'Registration Success!',
  'Thank you for joining us': 'Thank you for joining us.',
  'Login Now': 'Login Now',
  'Welcome Back': 'Welcome Back!',
  Login: 'Login',
  'Forgot password': 'Forgot password?',
  //todo ParentRegisterByLink Page

  //todo Event_Modal_Component Page
  'Send Email': 'Send Email',
  ETo: 'To',
  'Start Date': 'Start Date',
  'End Date': 'End Date',
  'Allow Parent Sign Up': 'Allow Parent Sign Up?',
  'Event Details': 'Event Details',
  'Maximum Participants': 'Maximum Participants',
  'Registration Cutoff (Days)': 'Registration Cutoff (Days)',
  'Event Registration Time': 'Event Registration Time',
  Duration: 'Duration',
  hour: 'hour',
  Location: 'Location',
  Tagged: 'Tagged ',
  'Add External Participant': 'Add External Participant',
  'Please enter participant emails separated by commas': 'Please enter participant emails separated by commas',
  'Parent Teacher Conference': 'Parent Teacher Conference',
  'School Closure': 'School Closure',
  'Public Holiday': 'Public Holiday',
  'Open Day': 'Open Day',
  'Term Break': 'Term Break',
  'School Holiday': 'School Holiday',
  'Please insert event title': 'Please insert event title.',
  'Please select date from': 'Please select date from.',
  'Please select event type': 'Please select event type.',
  'Please insert location': 'Please insert location.',
  'Please insert maximum participants': 'Please insert maximum participants.',
  'Please insert registration cutoff (days)': 'Please insert registration cutoff (days).',
  'Please insert registration time': 'Please insert registration time.',
  'Event Added': 'Event Added!',
  'Maximum participants should not lower than registered pax': 'Maximum participants should not lower than registered pax',
  'Event update successful': 'Event update successful',
  'Email duplicated': 'Email duplicated',
  'Please insert valid email': 'Please insert valid email',
  'File limit exceeded 2MB': 'File limit exceeded 2MB!',
  'File Format Not Accepted': 'File Format Not Accepted!',
  'Add Conferencing': 'Add Conferencing',
  Elearning: 'E-learning',
  'Select Start Datetime': 'Select Start Datetime',
  'Select End Datetime': 'Select End Datetime',
  'End datetime cannot smaller than start datetime': 'End datetime cannot smaller than start datetime!',
  min: 'min',
  'View time slot details': 'View time slot details',
  'Google Meet Link': 'Google Meet Link',
  'Select date range': 'Select date range',
  'Start Time': 'Start Time',
  'Select Start Time': 'Select Start Time',
  'Select End Time': 'Select End Time',
  'Creator Name': 'Creator Name',
  'Created On': 'Created On',
  'Allow Select Weekend': 'Allow Select Weekend',
  //todo Event_Modal_Component Page

  //todo EventBlastEmail Page
  'Number of guest': 'Number of guest',
  'Participant Deleted': 'Participant Deleted',
  'Email Sent': 'Email Sent',
  //todo EventBlastEmail Page

  //todo Event_ParentModal_Component Page
  'Hosted By': 'Hosted By',
  Time: 'Time',
  INVITATION: 'INVITATION',
  'Guest Pax': 'Guest Pax',
  'Event Registered': 'Event Registered!',
  'Select Timeslot': 'Select Timeslot',
  'Reset Email Password': 'Reset Email Password',
  'Delete Confirmation': 'Delete Confirmation',
  Successful: 'Successful',
  'Delete Error': 'Delete Error',
  'Selected Timeslot Date Time': 'Selected Timeslot Date Time',
  'All timeslots are booked': 'All timeslots are booked!',
  'Are you sure want to reset student gmail password': 'Are you sure want to reset student gmail password?',
  'Are you sure want to unselect this timeslot': 'Are you sure want to unselect this timeslot?',
  //todo Event_ParentModal_Component Page

  //todo PortfolioDetails Page
  Prev: 'Prev',
  Next: 'Next',
  'Finding Out': 'Finding Out',
  'Date of observation': 'Date of observation',
  'Connection with long-term goals': 'Connection with long-term goals',
  'Anecdotal Observations': 'Anecdotal Observations',
  'Learning Journeys Name': 'Learning Journeys Name',
  'Class Name': 'Class Name',
  //todo PortfolioDetails Page

  //todo Portfolio Page
  'Select a class': 'Select a class',
  'Select a student': 'Select a student',
  'No student selected': 'No student selected',
  'No updates posted for this student': 'No updates posted for this student',
  'Documenting Learning Journeys': 'Documenting Learning Journeys',
  'View Progress': 'View Progress',
  Selection: 'Selection',
  'Date and Time': 'Date and Time',
  Approved: 'Approved',
  'Review Required': 'Review Required',
  'Learning Journeys': 'Learning Journeys',
  'observations selected': 'observations selected',
  Progress: 'Progress',
  'Learning Journey Term and Big Ideas/Enduring Themes': 'Learning Journey Term and Big Ideas/Enduring Themes',
  'Please select Term, Please select Big Ideas/Enduring Themes': 'Please select Term, Please select Big Ideas/Enduring Themes',
  'Development Goals': 'Development Goals',
  'Rearrange Content': 'Rearrange Content',
  'Portfolio Description': 'Portfolio Description',
  //todo Portfolio Page

  //todo PlannerStudentProgress Page
  Posted: 'Posted ',
  'Posted Domains': 'Posted Domains',
  'No Posted': 'No Posted',
  'Pending Domains': 'Pending Domains',
  'No Pending': 'No Pending',
  'Posted Report': 'Posted Report',
  'Select Academic Year': 'Select Academic Year',
  'Select Term': 'Select Term',
  'Posted Domains Whole Academic Year': 'Posted Domains Whole Academic Year',
  'Posted Domains Summary': 'Posted Domains Summary',
  'View More Details': 'View More Details',
  'Pending Domains Whole Academic Year': 'Pending Domains Whole Academic Year',
  'Pending Domains Summary': 'Pending Domains Summary',
  'Pending Domain Details Whole Academic Year': 'Pending Domain Details Whole Academic Year',
  'Posted Domain Details Whole Academic Year': 'Posted Domain Details Whole Academic Year',
  'Pending Domain Details': 'Pending Domain Details',
  'Posted Domain Details': 'Posted Domain Details',
  Indicator: 'Indicator',
  Done: 'Done',
  Assign: 'Assign',
  //todo PlannerStudentProgress Page

  //todo PortfolioPreview Page
  'Portfolio Edit': 'Portfolio Edit',
  'Portfolio Name': 'Portfolio Name',
  'Enduring Themes/Transdisciplinary Themes': 'Enduring Themes/Transdisciplinary Themes',
  'No Remark Yet': 'No Remark Yet',
  Commenter: 'Commenter',
  'Research Question(s)/Unit(s) of Inquiry': 'Research Question(s)/Unit(s) of Inquiry',
  Approve: 'Approve',
  Reject: 'Reject',
  Rejected: 'Rejected',
  'Inquiry Cycle': 'Inquiry Cycle',
  'Date of Commenter': 'Date of Commenter',
  'Learning Journey Submitted Successfully': 'Learning Journey Submitted Successfully',
  'Please fill up all content': 'Please fill up all content',
  'Please fill in all fields': 'Please fill in all fields',
  'Cover Page': 'Cover Page',
  'Purpose of Learning Journey': 'Purpose of Learning Journey',
  'Programme of Inquiry/Intended Projects': 'Programme of Inquiry/Intended Projects',
  'Big Ideas': 'Big Ideas',
  'Key Concepts': 'Key Concepts',
  'Learner Profiles': 'Learner Profiles',
  "Child's Self-Portrait/Photo": "Child's Self-Portrait/Photo",
  'Upload from gallery': 'Upload from gallery',
  'Core Concepts': 'Core Concepts',
  'Save as draft': 'Save as draft',
  //todo PortfolioPreview Page

  //todo EventPostBack Page
  Files: 'Files',
  //todo EventPostBack Page

  //todo NavButton Page
  'News Feed': 'News Feed',
  Moments: 'Moments',
  'Termly Report': 'Summative Report',
  Planner: 'Planner',
  'Daily Log': 'Daily Log',
  'Declaration Form': 'Declaration Form',
  Survey: 'Survey',
  //todo NavButton Page

  //todo MainLibrary Page
  Publish: 'Published',
  Published: 'Published',
  'Added to post': 'Added to post',
  Library: 'Library',
  'Search Library': 'Search Library',
  'Select Directory': 'Select Directory',
  'Create New Folder': 'Create New Folder',
  'Move To Editor': 'Move To Editor',
  'Not found related files': 'Not found related files!',
  //todo MainLibrary Page

  //todo StaffFeed Page
  'Search Feed': 'Search Feed',
  'Parent Info': 'Parent Info',
  'Father Name': 'Father Name',
  'Mother Name': 'Mother Name',
  'Student Info': 'Student Info',
  'Student School': "Student's School",
  'Student Class': 'Student Class',
  'Student Level': 'Student Level',
  'Filter by': 'Filter by',
  //todo StaffFeed Page

  //todo StaffMoment Page
  'New Moments': 'New Moments',
  'Draft List': 'Draft List',
  Draft: 'Draft',
  'Moments Not Found': 'Moments Not Found!',
  'Select Class and Student': 'Select Class and Student',
  'Next Step': 'Next Step',
  'Previous Step': 'Previous Step',
  'Select Indicator': 'Select Indicator',
  'Fill in Title and Indicator': 'Fill in Title and Indicator',
  text: 'Text',
  layers: 'Layers',
  width: 'Width',
  height: 'Height',
  horizontal: 'Horizontal',
  vertical: 'Vertical',
  'line height': 'Line Height',
  'font size': 'Font Size',
  color: 'Color',
  bold: 'Bold',
  align: 'Align',
  tools: 'Tools',
  'selected tools': 'Selected Tools',
  settings: 'Settings',
  interaction: 'Interaction',
  onclick: 'On Click',
  link: 'Link',
  background: 'Background',
  picture: 'Picture',
  'All Moments': 'All Moments',
  //todo StaffMoment Page

  //todo Post_Broadcast_Component Page
  Subject: 'Subject',
  'Please enter a subject': 'Please enter a subject',
  'Please enter a message': 'Please enter a message',
  //todo Post_Broadcast_Component Page

  //todo MainNotificationComponent
  'You have Message': 'You have Message!',
  //todo MainNotificationComponent

  //todo TermlyReport
  'Create New': 'Create New',
  'Report List': 'Summative Report List',
  'Termly Report List': 'Summative Report List',
  'Back To List': 'Back to Summative Report List',
  'New Termly Report': 'New Summative Report',
  'Name of child': 'Name of Child',
  'Student Join Date': 'Date of Joining EtonHouse',
  'Current Age': 'Current Age',
  'Period of Report': 'Period of Report',
  'Date of Birth': 'Date of Birth',
  Class: 'Class',
  'Summary of In School Learning': 'Summary of In School Learning',
  'Comments from the Languge Specialist Teachers': 'Comments from the Languge Specialist Teachers',
  'Post Lists': 'Post Lists',
  'No Post Found': 'No Post Found',
  'Search Title': 'Search Title',
  'Published Report': 'Published Report',
  'View By List': 'View By List',
  'View By Post': 'View By Post',
  'Pending Action': 'Pending Actions',
  'No Termly Report Found': 'No Summative Report Found',
  //todo TermlyReport

  // plannerstudentassign
  'Learning Goals List': 'Learning Goals List',
  'Learning Goals': 'Learning Goals',
  'Learning Domains and Learning Goals': 'Learning Domains and Learning Goals',
  'Other List': 'Other List',
  'Other Level List': 'Other Level List',
  'New List': 'New List',
  Suggested: 'Suggested',
  'Other Level': 'Other Level',
  'Search Indicator': 'Search Indicator',
  Goals: 'Goals',
  Domain: 'Domain',
  'Filter By': 'Filter By',
  'Filter Type': 'Filter Type',
  'Filter Level': 'Filter Level',
  'Number of Learning Goals Assigned': 'Number of Learning Goals Assigned',
  View: 'View',
  'Learning goal documented for this academic year': 'Learning goal documented for this academic year',
  'Learning goal documented Summary': 'Learning goal documented Summary',
  'Learning goals to be documented for this academic year': 'Learning goals to be documented for this academic year',
  'Learning goals to be documented Summary': 'Learning goals to be documented Summary',
  'Learning goal documented': 'Learning goal documented',
  'Learning goal documented Summary': 'Learning goal documented Summary',
  'Learning goals to be documented': 'Learning goals to be documented',
  'Learning goals to be documented Summary': 'Learning goals to be documented Summary',
  Tracker: 'Tracker',
  'No learning goal documented': 'No learning goal documented',
  'Show Whole Academic Year': 'Show Whole Academic Year',
  'Hide Whole Academic Year': 'Hide Whole Academic Year',
  'No learning goals to be documented': 'No learning goals to be documented',
  'Select Academic Year': 'Select Academic Year',

  'Align left': 'Align left',
  'Align center': 'Align center',
  'Align justify': 'Align justify',
  'Align right': 'Align right',
  // plannerstudentassign

  //todo Portfolio_Component
  'Delete Selected Item': 'Delete Selected Item',
  //todo Portfolio_Component

  //todo NewMyAccount
  'Enable / Disable receive email reminder for new update': 'Enable / Disable receive email reminder for new update',
  'Your password needs to have at least 6 characters': 'Your password needs to have at least 6 characters.',
  'Back to main page': 'Back to main page',
  Account: 'Account',
  'Edit and manage your account details': 'Edit and manage your account details',
  'Upload Profile Image': 'Upload Profile Image',
  'BROWSE IMAGE': 'BROWSE IMAGE',
  //todo NewMyAccount

  //todo Activity
  'My Newsfeeds': 'My Newsfeeds',
  'My Moments': 'My Moments',
  'All Posts': 'All Newsfeeds',
  'All Moments': 'All Moments',
  'All Broadcasts': 'All Broadcast',
  'Search Post': 'Search post',
  'Search multiple keywords': 'Use a comma to separate multiple keywords',
  'Search Example': 'Search example: ABC, water play, new year celebration',
  'Showing To': 'Showing to:',
  'Show Less': 'Show less',
  'Show All': 'Show all',
  Tags: 'Tags',
  'Modified on': 'Modified on',
  'Post Type': 'Post Type',
  Level2: 'Level',
  'Select Teacher': 'Select teacher',
  'Filter Post': 'Filter post',
  'Clear All': 'Clear all',
  'Preview Post': 'Preview post',
  'Are you sure you want to delete this post?': 'Are you sure you want to delete this post?',
  'Are you sure to leave this page?': 'Are you sure you want to leave this page?',
  'Create New Post': 'Create new post',
  'Load From Template': 'Load from template',
  'Load From Draft': 'Load from draft',
  'Select Post Type': 'Select post type',
  Feeds: 'Newsfeed',
  Broadcasts: 'Broadcast',
  Moments: 'Moments',
  Newsfeed: 'Newsfeed',
  Rearrange: 'Rearrange',
  Browse: 'Browse',
  Replace: 'Replace',
  'Upload files max allow 5 each time': 'A maximum of 5 files are allowed each time.',
  'File with invalid format selected': 'Select file with valid format.',
  'Selected Student': 'Selected student(s)',
  'Selected Levels': 'Selected level(s)',
  'Selected Classes': 'Selected class(es)',
  LEVEL: 'Level',
  CLASS: 'Class',
  'Please input your remarks': 'Input remarks',
  'Save Draft': 'Save draft',
  'Save As Draft': 'Save as draft',
  'Are you sure you want to discard the content and back to activity page?': 'Are you sure you want to discard the content and go back to the Activity page?',
  'Publish on': 'Publish on',
  'Schedule post': 'Schedule post',
  'Publish Now': 'Publish Now',
  'Pick a date': 'Pick a date',
  'Save as template': 'Save as template',
  'Submit Post': 'Submit',
  'Save Template': 'Save Template',
  'Please Insert Post Title': 'Insert post title',
  'Please Insert Post Content': 'Insert post content',
  'Please Select Post Type': 'Select post type',
  'Video Uploading': 'Video uploading',
  'will be active in a while': 'File will be uploaded in a while.',
  activity: 'activity',
  'Post Updated': 'Post updated',
  'Draft Saved': 'Draft saved',
  'Please enter tags name': 'Enter tag name',
  'Select Template': 'Select template',
  'Select Draft': 'Select draft',
  Use: 'Select',
  'Are you sure you want to discard this template': 'Are you sure you want to discard this template?',
  'Show More': 'Show more',
  'Insert content here': 'Insert content here...',
  'Intended Project Update': 'Update',
  'Suggestions for Home-School Connection': 'Suggestions for Home-School Connection',
  'Language and Literacy Focus': 'Language and Literacy Focus',
  'Numeracy Focus': 'Numeracy Focus',
  Context: 'Context',
  Observation: 'Observation',
  'Please select a minimum of 3 Developmental Goals for the Analysis': 'Please select a minimum of 3 Developmental Goals for the Analysis',
  'Please select a minimum of 2 Learning Domains': 'Please select a minimum of 2 Learning Domains',
  //todo Activity

  //todo Planner
  GoalPlanner: 'Goal Planner',
  "Assign Individual Child's Learning Goals": 'Assign Learning Goals for Student',
  'Planner Assign Student': 'Planner Assign Student',
  'Planner Master': 'Planner Master',
  'New Master Planner': 'New Master Planner',
  'Assign Planner': 'Assign Planner',
  'Learning Domain': 'Learning Domain',
  'Learning Goal': 'Learning Goal',
  'Search Level': 'Search Level',
  'Search Domain': 'Search Domain',
  OTHER: 'OTHER',
  'NEL Goals': 'NEL Goals',
  'ITL NEL Goals': 'ITL NEL Goals',
  IndicatorType: 'IndicatorType',
  'New Planner Master': 'New Planner Master',
  'Select Level': 'Select Level',
  'Select Type': 'Select Type',
  'Fill in new Domain': 'Fill in new Domain',
  'Indicator Type': 'Indicator Type',
  Language: 'Language',
  'Select Language': 'Select Language',
  'Select School Type': 'Select School Type',
  'Select School': 'Select School',
  'School Type': 'School Type',
  'Un-Assign Planner': 'Un-Assign Planner',
  'Assigned Planner': 'Assigned Planner',
  'Planner Assigned': 'Planner Assigned',
  'Course Type': 'Course Type',
  'All Fields Required': 'All Fields Required',
  'Get Master Planner List: Error': 'Get Master Planner List: Error',
  'Save Master Planner List: Error': 'Save Master Planner List: Error',
  'Planner duplicated': 'Planner duplicated',
  'Delete Master Planner List: Error': 'Delete Master Planner List: Error',
  'Get Master Planner List Group By Domain: Error': 'Get Master Planner List Group By Domain: Error',
  'Delete Assigned Planner List: Error': 'Delete Assigned Planner List: Error',
  'Save Planner Details: Error': 'Save Planner Details: Error',
  'Get Un-Assign Planner List: Error': 'Get Un-Assign Planner List: Error',
  'Get Assigned Planner List: Error': 'Get Assigned Planner List: Error',
  'Get Planner Assigned To School List: Error': 'Get Planner Assigned To School List: Error',
  Term: 'Term',
  'Level Goals': 'Level goals and indicators',
  'Other Goals': 'Custom indicators',
  'No Custom Goals': 'No indicators added',
  'Custom Goals': 'Custom Goals',
  'Course Name': 'Level',
  'No of assigned Goals': 'No. of assigned indicators',
  'Please select Class & Term': 'Please select Class & Term...',
  'Class Goals Details: ERROR!!': 'Class Goals Details: ERROR!!',
  'Successfully Save': 'Successfully Save...',
  'The goal already exist in the list': 'The goal already exist in the list',
  'Add Custom Goals': 'Add custom indicators',
  'Select a class to start': 'Select a class to start',
  'Goal Planner': 'Planner ',
  'Enter Indicator': 'Enter Indicator ',
  'Goal:': 'Goal: ',
  'Goal Indicator': 'Indicators:',
  'Term 1': 'Term 1',
  'Term 2': 'Term 2',
  'Term 3': 'Term 3',
  'Term 4': 'Term 4',

  'Level Goal Planner': 'Level Planner',
  'View Learning Goals': 'View Learning Goals',
  'Level Assign': 'Assigned to level',
  'Level Goal Back': 'Level list',

  //todo Planner
}

export default EN
